module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Brain Date","bonusTitle":"Bonus Brain Date","bonusSubtitle":"You found a special brain date"},"en":{"title":"Brain Date","bonusTitle":"Bonus Brain Date","bonusSubtitle":"You found a special brain date"}}')
  delete Component.options._Ctor
}
